import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Button,
  Box,
  IconButton,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const PhotoEditDialog = ({ open, onClose, photoFiles, setPhotoFiles, setFormData }) => {
  // Добавление изображений
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const updatedFiles = [...photoFiles, ...files].slice(0, 10);
    setPhotoFiles(updatedFiles);
    setFormData((prev) => ({
      ...prev,
      photos: updatedFiles.map((file) => URL.createObjectURL(file)),
    }));
  };

  // Удаление изображений
  const handleDeletePhoto = (index) => {
    const updatedFiles = photoFiles.filter((_, i) => i !== index);
    setPhotoFiles(updatedFiles);
    setFormData((prev) => ({
      ...prev,
      photos: updatedFiles.map((file) => URL.createObjectURL(file)),
    }));
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Редактирование изображений</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          {photoFiles.map((file, index) => (
            <Grid item xs={4} key={index}>
              <Box className="edit-photo-box">
                <img
                  src={URL.createObjectURL(file)}
                  alt={`photo-${index}`}
                  className="edit-photo-preview"
                />
                <IconButton
                  size="small"
                  className="delete-photo-button"
                  onClick={() => handleDeletePhoto(index)}
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            </Grid>
          ))}
        </Grid>

        {/* Блок для кнопок */}
        <Box mt={2} display="flex" justifyContent="space-between">
          <Button variant="contained" component="label">
            Добавить изображения
            <input type="file" multiple accept="image/*" hidden onChange={handleFileChange} />
          </Button>
          <Button onClick={onClose} color="primary" variant="contained">
            Сохранить изменения
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PhotoEditDialog;
